<template>
	<div>
		<q-table
			ref="table"
			:data="certificates"
			:columns="columns_certificates"
			row-key="id"
			:pagination.sync="server_pagination"
			@request="requestCertificates"
			:loading="loading"
			:no-data-label="$t('no_data_avaliable')"
			:no-results-label="$t('no_results_found')"
			:loading-label="$t('loading_data')"
			:rows-per-page-label="$t('items_per_page')"
			:rows-per-page-options="[5, 10, 50, 100]"
			:filter="filter_certificates"
			binary-state-sort
			class="q-mt-lg"
		>
			<template slot="top" slot-scope="props" :props="props">
				<q-search
					v-model="filter_certificates"
					icon="far fa-search"
					:placeholder="$t('search')"
					:debounce="500"
				/>

				<div class="col" />

				<q-btn
					color="secondary"
					icon="fas fa-download"
					:label="$t('certified_report')"
					v-if="permissions.reports"
					@click="downloadCertificate()"
				/>
			</template>

			<q-tr slot="header" slot-scope="props" :props="props">
				<q-th v-for="col in props.cols" :key="col.name" :props="props">
					{{ $t(col.label) }}
				</q-th>
			</q-tr>

			<template slot="body" slot-scope="props">
				<q-tr :props="props">
					<q-td key="user_full_name" :props="props">
						{{ props.row.user_full_name }}
					</q-td>

					<q-td key="user_email" :props="props">
						{{ props.row.user_email }}
					</q-td>

					<q-td key="result_date" :props="props">
						{{ props.row.result_date }}
					</q-td>

					<q-td key="score" :props="props">
						{{ props.row.score ? props.row.score.toFixed(2) : '' }}
					</q-td>

					<q-td key="expiration_date" :props="props">
						{{ props.row.expiration_date }}
					</q-td>

					<q-td key="expired" :props="props">
						<q-chip
							v-if="props.row.expire !== null"
							small
							:icon="getIconExpire(props.row.expire)"
							:color="getColorExpire(props.row.expire)"
							class="full-width text-center"
						>
							{{ $t(getTextExpire(props.row.expire)) }}
						</q-chip>
					</q-td>

					<q-td key="status" :props="props" auto-width>
						<q-chip
							small
							:icon="getIconStatus(props.row.status)"
							:color="getColorStatus(props.row.status)"
							class="full-width text-center"
						>
							{{ $t(getTextStatus(props.row.status)) }}
						</q-chip>
					</q-td>

					<q-td key="user_branches" :props="props">
						<q-btn
							color="primary"
							text-color="white"
							:label="props.row.user_branches ? props.row.user_branches.length : 0"
							no-ripple
						>
							<q-tooltip>
								<p
									v-if="
										props.row.user_branches &&
											props.row.user_branches.length > 0
									"
									class="tooltip q-mb-sm"
								>
									{{ $t('branches') }}:
									<span
										v-for="(branch, index) in props.row.user_branches"
										:key="index"
									>
										{{ branch }}
										<span v-if="props.row.user_branches.length - 1 > index"
											>,
										</span>
									</span>
								</p>
							</q-tooltip>
						</q-btn>
					</q-td>
				</q-tr>
			</template>
		</q-table>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
	name: 'AdminPresentialReportCertificate',

	props: ['load', 'status', 'id', 'permissions'],

	data() {
		return {
			server_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: null,
				descending: false,
				sortBy: null,
			},
			certificates: [],
			columns_certificates: [
				{
					name: 'user_full_name',
					required: true,
					label: 'name',
					align: 'left',
					field: 'user_full_name',
					sortable: true,
				},
				{
					name: 'user_email',
					required: true,
					label: 'email',
					align: 'left',
					field: 'user_email',
					sortable: true,
				},
				{
					name: 'result_date',
					required: true,
					label: 'date',
					align: 'left',
					field: 'result_date',
					sortable: true,
				},
				{
					name: 'score',
					required: true,
					label: 'score',
					align: 'left',
					field: 'score',
					sortable: true,
				},
				{
					name: 'expiration_date',
					required: true,
					label: 'expiration_date',
					align: 'left',
					field: 'score',
					sortable: true,
				},
				{
					name: 'expired',
					required: true,
					label: 'expired',
					align: 'left',
					field: 'score',
					sortable: true,
				},
				{
					name: 'status',
					required: true,
					label: 'status',
					align: 'left',
					field: 'status',
					sortable: true,
				},
				{
					name: 'user_branches',
					required: true,
					label: 'branches',
					align: 'center',
					field: 'user_branches',
					sortable: false,
				},
			],
			loading: false,
			filter: '',
			filter_certificates: '',
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected',
			id_user_language_selected: 'common/id_user_language_selected',
			num_rows: 'datatable/num_rows',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '80vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},
	},

	methods: {
		requestCertificates({ pagination }) {
			this.loading = true
			this.server_pagination = pagination

			let order = pagination.descending ? '-' : ''
			let order_by = pagination.sortBy ? order + pagination.sortBy : ''

			let data = {
				page_size: this.server_pagination.rowsPerPage,
				page: this.server_pagination.page,
				ordering: order_by,
				search: this.filter_certificates,
			}

			this.savePagination()

			this.$axios
				.get(
					`/presential/presential_events/${
						this.id
					}/reports/presential_event_user_results/?${this.$qs.stringify(data)}`,
					this.getHeader
				)
				.then((response) => {
					this.server_pagination.rowsNumber = response.data.count

					if (response.data) {
						this.certificates = response.data.results
							? response.data.results.map((e) => {
									return {
										...e,
										expiration_date: e.expiration_date
											? date.formatDate(
													e.expiration_date,
													'DD/MM/YYYY HH:mm:ss'
											  )
											: '',
										result_date: e.result_date
											? date.formatDate(e.result_date, 'DD/MM/YYYY HH:mm:ss')
											: '',
										user_branches: e.user_branches ? e.user_branches : [],
									}
							  })
							: []
					}
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loading = false
				})
		},

		getTextStatus(status) {
			if (status === 1) return 'approved'
			else if (status === 2) return 'reproved'
			else return 'pending'
		},

		getColorStatus(status) {
			if (status === 1) return 'positive'
			else if (status === 2) return 'negative'
			else return 'tertiary'
		},

		getIconStatus(status) {
			if (status === 1) return 'fal fa-check'
			else if (status === 2) return 'fal fa-times'
			else return 'fal fa-clock'
		},

		getTextExpire(expire) {
			return expire ? 'expired' : 'valid'
		},

		getIconExpire(expire) {
			return expire ? 'fal fa-times' : 'fal fa-check'
		},

		getColorExpire(expire) {
			return expire ? 'negative' :  'positive'
		},

		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'save') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},

		fDate(d) {
			if (d) {
				let format = ''

				switch (this.id_user_language_selected) {
					case 1:
					case 3:
						format = 'DD/MM/YYYY HH:mm:ss'
						break
					default:
						format = 'MM-DD-YYYY HH:mm:ss'
						break
				}

				return date.formatDate(d, format)
			}
		},

		savePagination() {
			this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
		},

		loadPagination() {
			this.server_pagination.rowsPerPage = this.num_rows
		},

		downloadCertificate() {
			let message = this.$t('generating_import_file_message')
			this.$q.loading.show({
				message,
			})
			this.$axios
				.get(
					`/presential/presential_events/${
						this.id
					}/reports/presential_event_user_results/generate_report/`,
					this.getHeader
				)
				.then((response) => {
					this.forceFileDownload(response.data.path_url)
				})
				.catch((e) => {
					this.loading = false
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		forceFileDownload(response) {
			const link = document.createElement('a')
			link.href = response
			document.body.appendChild(link)
			link.click()
		},
	},

	watch: {
		load: function() {
			if (this.load) {
				this.requestCertificates({ pagination: this.server_pagination })
			}
		},

		num_rows: {
			handler: function(newValue) {
				this.loadPagination()
			},
			deep: true,
		},
	},

	mounted() {
		this.loadPagination()
		this.requestCertificates({ pagination: this.server_pagination })
	},
}
</script>

<style></style>
